import Call from '../../Call.v2';

const Offers = {
    get() {
        return Call(`filler/offers`);
    },

    save(event) {
        return Call(`filler/offers`, 'POST', event);
    },

    update(id, event) {
        return Call(`filler/offers/${id}`, 'PUT', event);
    },

    remove(id) {
        return Call(`filler/offers/${id}`, 'DELETE');
    },
};

export default Offers;


// WEBPACK FOOTER //
// ./src/services/API/components/Filler/Offers.js